<template>
  <div class="flex flex-col gap-0.5 leading-tight">
    <div class="font-semibold">
      <span v-if="ownerName">{{ ownerName }}</span>
      <span v-else class="italic text-gray-400">Owner {{ props.data.Id }}</span>
      <span v-if="props.data.Id" class="ml-1 font-normal text-gray-400">
        (Owner {{ props.data.Id }})
      </span>
    </div>

    <div v-if="props.data.Rekno" class="text-sm text-gray-500">
      Account: {{ props.data.Rekno }}
    </div>

    <div v-if="contact" class="text-sm text-gray-400">
      {{ contact }}
    </div>
  </div>
</template>

<script setup lang="ts">
interface AuxInputProps {
  data: any;
}

const props = defineProps<AuxInputProps>();

// owner_view exposes Names (plural) and Surname.
const ownerName = computed(() =>
  [props.data?.Names, props.data?.Surname].filter(Boolean).join(" ").trim()
);

const contact = computed(() => {
  const parts = [];
  if (props.data?.CellPhoneNumber)
    parts.push(`Cell: ${props.data.CellPhoneNumber}`);
  if (props.data?.EMailAddress) parts.push(props.data.EMailAddress);
  return parts.join(" | ");
});
</script>

<style scoped></style>
